import { render, staticRenderFns } from "./productPage.vue?vue&type=template&id=5d8b9a3a&scoped=true&"
import script from "./productPage.vue?vue&type=script&lang=js&"
export * from "./productPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8b9a3a",
  null
  
)

export default component.exports